import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

export default function UpgradeConfirmModal({ isOpen, onClose, prorrateo, loadingPreview, processing, onConfirm }) {
  const { t } = useTranslation('billing');
  const { t: tc } = useTranslation('common');

  if (!isOpen) return null;

  const handleConfirm = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content cancel-addon-modal" onClick={e => e.stopPropagation()}>
        <h3>{t('upgradeModal.title')}</h3>
        {loadingPreview || !prorrateo ? (
          <p>{t('upgradeModal.calculating')}</p>
        ) : (
          <p>
            <Trans
              t={t}
              i18nKey="upgradeModal.message"
              values={{ amount: prorrateo.monto, currency: prorrateo.moneda }}
              components={{ strong: <strong /> }}
            />
          </p>
        )}
        <div className="modal-actions">
          <button
            className="btn-cancel-confirm"
            onClick={handleConfirm}
            disabled={processing || loadingPreview || !prorrateo}
          >
            {processing ? tc('processing') : t('upgradeModal.confirm')}
          </button>
          <button className="btn-cancel-back" onClick={onClose} disabled={processing}>
            {t('upgradeModal.back')}
          </button>
        </div>
      </div>
    </div>
  );
}
